import "core-js/stable";
import "regenerator-runtime/runtime";

import Vue from "vue";

import Bugsnag from "./utils/bugsnag";

import Vuex, { mapActions, mapGetters } from "vuex";
import Buefy from "buefy";
import Scrollactive from "vue-scrollactive";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import AppLogo from "@/components/AccessLogo.vue";

import FormFields from "@shared/Forms/Fields";
import Authentication from "@shared/authentication";

import AppSectionHeading from "@/components/AppSectionHeading.vue";
import AppEmptyTable from "@/components/AppEmptyTable.vue";
import AppIsFetching from "@/components/AppIsFetching.vue";
import AppTipText from "@/components/AppTipText.vue";
import AppFormInfo from "@/components/AppFormInfo.vue";
import VueIntercom from "vue-intercom";
import * as VueGoogleMaps from "vue2-google-maps";
import formLoad from "./components/form/load";
import DcIcon from "@lab/components/dcicon/";
import AppProgressLoader from "@shared/components/ProgressLoader.vue";
import VueScrollTo from "vue-scrollto";
import AirbnbStyleDatepicker from "vue-airbnb-style-datepicker-date-fns-2";
import { shortenNumber, currency } from "@lab/utils/format";
import ReadMore from "vue-read-more";
import { releaseDate } from "@shared/components/DeployDate/releaseDate";

import VueClipboard from "vue-clipboard2";

Vue.component("AppLogo", AppLogo);

// Set cache check variable
(window as any).dailycareexists = true;

Vue.filter("shortenNumber", shortenNumber);
Vue.filter("currency", currency);

Vue.use(FormFields);
Vue.use(Authentication, { router });

Vue.use(DcIcon, {});

Vue.use(VueClipboard);

Vue.config.productionTip = false;
// Vue.config.devtools = true;

Vue.use(VueIntercom, {
	appId: process.env.VUE_APP_ACCESS_INTERCOM_APPID
});

Vue.use(VueGoogleMaps, {
	load: {
		key: process.env.VUE_APP_GOOGLE_MAP_API_KEY,
		libraries: ["places", "visualization"]
	}
});

Vue.use(Vuex);
Vue.use(Buefy, {
	defaultIconPack: "fa"
});
Vue.use(Scrollactive);
Vue.mixin(formLoad);

Vue.use(VueScrollTo);

// You can also pass in the default options
Vue.use(VueScrollTo, {
	container: "body",
	duration: 500,
	easing: "ease",
	offset: 0,
	cancelable: true,
	onStart: false,
	onDone: false,
	onCancel: false,
	x: false,
	y: true
});

// see docs for available options
const datepickerOptions = {};

// make sure we can use it in our components
Vue.use(AirbnbStyleDatepicker, datepickerOptions);

Vue.use(ReadMore);

// These are our global NICE things!
Vue.mixin({
	data() {
		return {
			google: VueGoogleMaps
		};
	},
	computed: {
		...mapGetters({
			currentUser: "userModule/get",
			userConfig: "userModule/config"
		}),
		isSuper() {
			return true;
		}
	},
	methods: {
		notify(message, type, duration) {
			this.$buefy.toast.open({
				duration: duration || 5000,
				message,
				type: type || "is-success",
				position: "is-top",
				queue: false
			});
		},
		confirm(title, message, type, actionText, action) {
			this.$buefy.dialog.confirm({
				title,
				message,
				confirmText: actionText,
				type: type || "is-warning",
				hasIcon: true,
				onConfirm: action
			});
		}
	}
});

// Load global components
Vue.component("AppSectionHeading", AppSectionHeading);
Vue.component("AppEmptyTable", AppEmptyTable);
Vue.component("AppIsFetching", AppIsFetching);
Vue.component("AppTipText", AppTipText);
Vue.component("AppFormInfo", AppFormInfo);
Vue.component("AppProgressLoader", AppProgressLoader);

new Vue({
	el: "#app",
	router,
	store,
	components: {
		App
	},
	computed: {
		...mapGetters({
			token: "userModule/token"
		})
	},
	watch: {
		$route() {
			return (window as any).Intercom("update");
		}
	},
	async mounted() {
		if (this.token) {
			await this.refresh();
		}
		if (!(window as any).Cypress && this.currentUser) {
			// this.$intercom.boot(intercomData(this.currentUser));
		}
		// adding userId to the dataLayer for use in gtm
		if (this.currentUser) {
			// myStore.dispatch("datalayer/push", {
			// 	userId: user.id,
			// 	orgId: user.organisationid,
			// 	event: "authentication",
			// 	dnt: navigator.doNotTrack
			// });
			if (Bugsnag) {
				Bugsnag.setUser(
					this.currentUser.id,
					this.currentUser.email,
					`${this.currentUser.firstname} ${this.currentUser.lastname}`
				);
				Bugsnag.addMetadata("user", {
					type: this.currentUser.type
				});
			}
		}
		// if (releaseDate) {
		// 	myStore.dispatch("adChecker/check");
		// }
	},
	methods: {
		...mapActions({
			refresh: "userModule/refresh"
		})
	},
	template: "<App/>"
	// force
});
